export const USER_TOKEN = 'USER_TOKEN'
export const READER_PAGE = 'READER_PAGE'
export const LOCALIZATION = 'LOCALIZATION' 
export const READING_MODE = 'READING_MODE'
